export default __webpack_public_path__ + "static/media/mailsend.a7865d00.svg";